module.exports = __webpack_public_path__ + "media/images/japan/tokyo_picture-5d02adefeee5820d940b0031ef72ec26.png";